import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BbReactComponent } from 'app/components/shared/bb-react/bb-react.component';
import { Project } from 'app/interfaces/project';

@Component({
	selector: 'library-project-details-react',
	templateUrl: './library-project-details-react.component.html'
})
export class LibraryProjectDetailsReactComponent implements OnInit {
	@Input() project: Project;
	@Input() isActive: boolean;
	@Input() form: NgForm;

	@ViewChild(BbReactComponent) reactComponent: BbReactComponent;

	entity: Project;

	constructor() {
	}

	ngOnInit() {
		this.entity = this.project;
	}

	// cancel from bb action bar
	cancel(): void {
		this.reactComponent.cancel();
	}
}
